import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Switch, Select, Tag } from 'antd';
import { Eye, Settings, Image as ImageIcon } from 'react-feather';
import { PushpinOutlined } from '@ant-design/icons';
import unpinIcon from '../../../../../../assets/icons/ic_unpin.svg';
import cashIcon from '../../../../../../assets/images/cash.png';
import coinIcon from '../../../../../../assets/images/coin.png';

import styles from './stylesSortableItem.module.css';
import ToggleSwitch from '../../../../../CommonComponents/ToggleSwitch/ToggleSwitch';
import ClipPath from '../../../../../../assets/icons/ic_clip-path.svg';
const { Option } = Select;

const SortableItem = ({
  game,
  toggleStatus,
  onTogglePin,
  betAmountType,
}) => {
  const [logoErrors, setLogoErrors] = useState({
    home: false,
    away: false
  });

  const handleLogoError = (logoType) => {
    setLogoErrors(prev => ({ ...prev, [logoType]: true }));
  };

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: game.game_id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: isDragging ? 'grabbing' : 'grab',
    filter: game.is_active ? 'none' : 'opacity(0.8)',
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={`${styles.rowExpanded} ${styles.sortableItem} ${game.is_pinned ? styles.pinnedRow : ''}`}
    >
      <td className={styles.expandCell}></td>
      <td className={styles.expandCell}></td>
      <td className={styles.expandCell}></td>
      <td className={styles.dragCell}>
        <div className={styles.dragCellContent}>
          <div className={styles.dragHandle} {...listeners}>
            <img src={ClipPath} alt="Drag" />
          </div>
          <div className={styles.pinIconContainer}>
            {game.is_pinned ? (
              <img
                src={unpinIcon}
                alt="Pin"
                className={`${styles.pinIcon} ${styles.unpinned}`}
                onClick={() => onTogglePin(game)}
              />
            ) : (
              <PushpinOutlined
                className={`${styles.pinIcon} ${styles.pinned}`}
                onClick={() => onTogglePin(game)}
              />
            )}
          </div>
        </div>
      </td>
      {/* <td className={styles.iconCell}>
        <div className={styles.eventIconContainer}>
          <img src={game.image || game.icon} alt={game.name} className={styles.eventIcon} />
        </div>
      </td> */}
      {/* <td className={styles.leagueCell}>
        <span className={styles.leagueName}>{game.leagueName || 'SEASON CELTICS vs PM...'}</span>
      </td> */}
      <td className={styles.idCell}>
        <span className={styles.eventId}>#{game.game_id}</span>
      </td>
      <td className={styles.eventNameCell}>
        <div className={styles.eventWithLogos}>
          <div className={styles.teamLogos}>
            <div className={styles.teamLogo}>
              {game.home_logo && game.home_logo.trim() !== '' && !logoErrors.home ? (
                <img
                  src={game.home_logo}
                  alt="Home Team"
                  className={styles.logoImage}
                  onError={() => handleLogoError('home')}
                />
              ) : (
                <div
                  className={styles.placeholderLogo}
                  title="No home team logo"
                >
                  <ImageIcon size={18} />
                </div>
              )}
            </div>
            <div className={styles.teamLogo}>
              {game.away_logo && game.away_logo.trim() !== '' && !logoErrors.away ? (
                <img
                  src={game.away_logo}
                  alt="Away Team"
                  className={styles.logoImage}
                  onError={() => handleLogoError('away')}
                />
              ) : (
                <div
                  className={styles.placeholderLogo}
                  title="No away team logo"
                >
                  <ImageIcon size={18} />
                </div>
              )}
            </div>
          </div>
          <span className={styles.eventName}>{game.name}</span>
        </div>
      </td>
      <td className={styles.expandCell}></td>
      <td className={styles.expandCell}></td>
      <td className={styles.expandCell}></td>
      {/* <td className={styles.orderCell}>
        <span className={styles.orderNumber}>{game.order || '1'}</span>
      </td> */}
      {/* <td className={styles.statusCell}>
        <span className={styles.statusText}>{game.is_active ? 'Active' : 'Inactive'}</span>
      </td> */}
      {/* <td className={styles.actionCell}>
        <div className={styles.actionButtons}>
          <Button
            type="text"
            icon={<Eye size={12} />}
            className={styles.viewButton}
          />
          <Button
            type="text"
            icon={<Settings size={12} />}
            className={styles.settingsButton}
          />
        </div>
      </td> */}
      <td className={styles.eventDateCell}>
        <span className={styles.eventDate}>{game.eventDate}</span>
      </td>
      <td className={styles.status2Cell}>
        <Tag className={styles.statusBadge}>{game.status}</Tag>
      </td>
      <td className={styles.countryCell}>
        <span className={styles.country}>{game.country}</span>
      </td>
      <td className={styles.locationCell}>
        <span className={styles.location}>{game.location}</span>
      </td>
      <td className={styles.providerCell}>
        <span className={styles.provider}>{game.provider}</span>
      </td>
      <td className={styles.betsAmountCell}>
        <div className={styles.betsAmountContainer}>
          <img
            src={betAmountType === 'coin' ? coinIcon : cashIcon}
            alt={betAmountType === 'coin' ? 'Coin' : 'Cash'}
            className={styles.currencyIcon}
          />
          <span className={styles.betsAmount}>
            {betAmountType === 'coin'
              ? ((game.betsAmount || 0) * 0.1).toLocaleString() // Convert to coin value (example: 10% of cash value)
              : (game.betsAmount || 0).toLocaleString()
            }
          </span>
        </div>
      </td>
      <td className={styles.numberOfBetsCell}>
        <div className={styles.betsCountContainer}>
          {/* <span className={styles.userIcon}>👤</span> */}
          <span className={styles.betsCount}>{game.numberOfBets || 0}</span>
        </div>
      </td>
      <td className={styles.preMatchTierCell}>
        <Select
          value={game.preMatchTier}
          className={styles.tierSelect}
        >
          <Option value={1}>1</Option>
          <Option value={2}>2</Option>
          <Option value={3}>3</Option>
        </Select>
      </td>
      <td className={styles.liveTierCell}>
        <Select
          value={game.liveTier}
          className={styles.tierSelect}
        >
          <Option value={1}>1</Option>
          <Option value={2}>2</Option>
          <Option value={3}>3</Option>
        </Select>
      </td>
      <td className={styles.liveTimeDelayCell}>
        <Select
          value={game.liveTimeDelay}
          className={styles.tierSelect}
        >
          <Option value={1}>1</Option>
          <Option value={2}>2</Option>
          <Option value={3}>3</Option>
        </Select>
      </td>
      <td className={styles.suggestedLiveCell}>
        <span className={styles.suggestedLive}>{game.suggestedLive || '-'}</span>
      </td>
      <td className={styles.preMatchActivityCell}>
        <ToggleSwitch
          status={game.preMatchActivity}
          eventCode={1}
          updateEventCode={toggleStatus}
          data={game}
          onlyUpdate={true}
        />
      </td>
      <td className={styles.liveActivityCell}>
        <ToggleSwitch
          status={game.liveActivity}
          eventCode={1}
          updateEventCode={toggleStatus}
          data={game}
          onlyUpdate={true}
        />
      </td>
    </tr>
  );
};

export default SortableItem;
